import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2qwgasr6b7: FaireBrandEntity = {
  token: "b_2qwgasr6b7",
  type: "brand",
  name: "Cities in Dust Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/b077762df81000834da83e18e36cd80f27149afa0e5a772ab4d6e814981883d5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/96ac0a02ae646478e6d5b3b6cb504bd80bfde92ea86527a9e289a03dead31dee.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b077762df81000834da83e18e36cd80f27149afa0e5a772ab4d6e814981883d5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/96ac0a02ae646478e6d5b3b6cb504bd80bfde92ea86527a9e289a03dead31dee.png",
  location: "chicago, IL, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 7,
  isInsider: true,
  description:
    "Cities In Dust Jewelry is based in Chicago, IL. It is a playful and nostalgic accessory brand with a modern spin. We pride ourself on a strong ability to forecast trends and tie in elements of the past to create the narrative of our customer. We enjoy story telling and reminiscing. We are an all female run business based in Chicago. All of our work is handmade here in our studio; however, some of our components are made overseas. We stick to our mission of being an inclusive and accessible brand for everyone. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:30.846Z",
    importedBy: "entity-db-cli",
  },
};
